import type { LevelThreeProgressItem } from '@lemonade-hq/uniclient-chat';
import { Flex, spacing } from '@lemonade-hq/uniclient-theme';
import { motion } from 'motion/react';
import { forwardRef } from 'react';
import { progressSubItemsWrapperVariants } from '../animations';
import { LEVEL_TWO_GAP } from '../constants';
import type { AnimationProgressProps } from '../types';
import { ProgressSubSubItem } from './ProgressSubSubItem';

interface ProgressSubSubItemsWrapperProps extends Pick<AnimationProgressProps, 'isBackwards'> {
  readonly items: LevelThreeProgressItem[];
  readonly isFirstRender: boolean;
  readonly currentSubSubItemIndex: NonNullable<AnimationProgressProps['currentSubSubItemIndex']>;
}

export const ProgressSubSubItemsWrapper = forwardRef<HTMLDivElement, ProgressSubSubItemsWrapperProps>(
  ({ items, currentSubSubItemIndex, isFirstRender, isBackwards }, _) => {
    return (
      <Flex
        {...progressSubItemsWrapperVariants}
        as={motion.div}
        flexDirection="column"
        gap={LEVEL_TWO_GAP}
        marginInlineStart={spacing.s08}
        position="relative"
      >
        {items.map((subSubItem, index) => (
          <ProgressSubSubItem
            completed={index < currentSubSubItemIndex}
            current={index === currentSubSubItemIndex}
            isBackwards={isBackwards}
            isExpanding={currentSubSubItemIndex === 0}
            isFirst={index === 0}
            isFirstRender={isFirstRender}
            item={subSubItem}
            key={subSubItem.id}
          />
        ))}
      </Flex>
    );
  },
);
